if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
 function initializeCardTapBehavior() {
    if (window.innerWidth > 768) return;

    document.querySelectorAll(".card-wrapper").forEach((card) => {
      let tapped = false;

      // Prevent double binding
      card.removeEventListener("click", card._tapHandler);
      card._tapHandler = function (e) {
        if (!tapped) {
          e.preventDefault();
          card.classList.add("show-add-button");
          tapped = true;

          setTimeout(() => {
            tapped = false;
            card.classList.remove("show-add-button");
          }, 10000);
        }
      };
      card.addEventListener("click", card._tapHandler);

      // Remove previous document listeners to avoid duplicates
      document.removeEventListener("click", card._outsideClickHandler);
      card._outsideClickHandler = function (event) {
        if (!card.contains(event.target)) {
          tapped = false;
          card.classList.remove("show-add-button");
        }
      };
      document.addEventListener("click", card._outsideClickHandler);

      // Re-apply class on DOM change
      const observer = new MutationObserver(() => {
        if (tapped && !card.classList.contains("show-add-button")) {
          card.classList.add("show-add-button");
        }
      });
      observer.observe(card, { childList: true, subtree: true });
    });
  }

  // Initial call
  document.addEventListener("DOMContentLoaded", initializeCardTapBehavior);

  // Shopify page navigation (for themes using Turbo, PJAX, etc.)
  document.addEventListener("shopify:section:load", initializeCardTapBehavior);
  document.addEventListener("shopify:section:unload", initializeCardTapBehavior);
  document.addEventListener("shopify:section:select", initializeCardTapBehavior);
  document.addEventListener("shopify:section:deselect", initializeCardTapBehavior);

  // Optional: add a fallback delay
  setTimeout(initializeCardTapBehavior, 2000);